<template>
    
</template>
<script>
export default {
    name:'StockBalance'
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/stockManagement/stockBalance/StockBalance.vue